<template>
    <v-container>
        <v-layout row>
            <v-flex xs12
                    sm6
                    offset-sm3>
                <v-card>
                    <v-card-text>
                        <v-container>
                            <form @submit.prevent="signIn">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field name="email"
                                                      label="Mail"
                                                      id="email"
                                                      v-model="email"
                                                      type="email"
                                                      autofocus
                                                      required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field name="password"
                                                      label="Password"
                                                      id="password"
                                                      v-model="password"
                                                      type="password"
                                                      required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn type="submit">Sign in</v-btn>
                                        <span class="red--text"
                                              v-if="notVerified === true">Another verification email has been set to your email address. Please check you Spam filter.</span>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex>
                                        <v-btn flat
                                               small
                                               color="teal"
                                               @click.native="forgotPassword = true">
                                            Forgot Password
                                        </v-btn>
                                    </v-flex>
                                </v-layout>

                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="forgotPassword"
                  max-width="400">
            <v-card>
                <v-card-title>
                    <span class="headline">Forgot Password</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>

                            <v-flex xs12>
                                <v-text-field v-model="email"
                                              :rules="emailRules"
                                              label="Email"
                                              required></v-text-field>
                            </v-flex>

                        </v-layout>
                    </v-container>
                    <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1"
                           flat
                           @click.native="forgotPassword = false">Cancel</v-btn>
                    <v-btn color="blue darken-1"
                           flat
                           @click.native="sendEmail()">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'login',
  data: function () {
    return {
      email: '',
      password: '',
      notVerified: false,
      forgotPassword: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid']
    }
  },
  methods: {
    sendEmail: function () {
      this.forgotPassword = false
      firebase.auth().sendPasswordResetEmail(this.email).then(function () {
        alert('Email Sent')
      }).catch(function (error) {
        alert('Oops. ' + error.message)
      })
    },
    signIn: function () {
      // logout
      this.$emit('logout', true)

      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          if (user.emailVerified) {
            this.$router.replace('viewfreight')
          } else {
            this.notVerified = true
            user.sendEmailVerification()
          }
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Login.vue